import { DesignBurdenParams } from "@app/models/chart-data.model";
import { putPromise } from "./request-promise";

interface BurdenResponseRow {
	project: string;
	averageBurden: number;
	designBurden: number;
	datasetId?: number;
}

export function updateDesignBurdens(designBurdenParams:DesignBurdenParams) {
	return putPromise<{ data: BurdenResponseRow[]; message: string }>(
		'api/dashboards/highchart_analytics/add_design_burden',
		designBurdenParams,
		(data) => data || null
	);
}